import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#cf243d",
      d: "M0 18.667C0 12.133 0 8.866 1.272 6.37A11.67 11.67 0 0 1 6.37 1.272C8.866 0 12.133 0 18.667 0h2.666c6.534 0 9.801 0 12.297 1.272a11.67 11.67 0 0 1 5.098 5.098C40 8.866 40 12.133 40 18.667v2.666c0 6.534 0 9.801-1.272 12.297a11.67 11.67 0 0 1-5.098 5.098C31.134 40 27.867 40 21.333 40h-2.666c-6.534 0-9.801 0-12.297-1.272a11.67 11.67 0 0 1-5.098-5.098C0 31.134 0 27.867 0 21.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m32.619 24.917-.015.178c-.057.694-.492 1.396-1.214 1.396-.552 0-.996-.204-1.358-.624-.435-.5-.826-1.102-1.222-2.193 1.122-3.806 4.58-16.001 4.58-16.001h-6.564s-.606 2.86-1.153 5.46l-.084-.186c-.547-1.17-1.421-2.47-2.391-3.383-1.692-1.59-3.68-2.365-6.082-2.365-3.315 0-6.12 1.227-8.336 3.646-2.205 2.405-3.37 5.49-3.37 8.922 0 3.822 1.106 6.961 3.288 9.326 2.275 2.472 4.996 3.623 8.56 3.623 2.077 0 4.059-.617 5.896-1.833 1.187-.784 2.27-1.87 3.294-3.28.43 1.392.863 2.343 1.381 3.056.838 1.15 2.094 1.808 3.445 1.808 1.406 0 2.686-.72 3.344-1.878.582-1.028.82-2.303.82-4.4v-1.273zm-11.005 2.437c-.995 1.458-2.294 2.227-3.758 2.227-1.705 0-2.995-.764-3.944-2.344-.996-1.654-1.5-4.132-1.5-7.368 0-2.966.535-5.324 1.588-7.008.99-1.58 2.23-2.318 3.904-2.318 1.49 0 2.652.62 3.663 1.953 1.083 1.43 1.999 3.795 2.654 6.835-.823 4.108-1.628 6.592-2.607 8.023"
    }, null, -1)
  ]))]))
}
export default { render: render }